import Consts from '../../consts/adminConsts'

export default class {
    Id = null;

    QuestionId = null;

    ParentQuestionId = null;

    RelationType = null;

    ConditionType = null;

	Value = null;
	
	VisibleCondition = null;

    mapFromDto(dto) {
        if(!dto)
            return this;

        this.Id = dto.Id;
        this.QuestionId = dto.QuestionId;
        this.ParentQuestionId = dto.ParentQuestionId;

        this.RelationType = Consts.RelationTypes.find(e => e.Id == dto.RelationType);
        this.ConditionType = this.RelationType.Id === 1
                                ? Consts.ConditionTypes.find(e => e.Id == dto.ConditionType)
								: Consts.TradePointConditionTypes.find(e => e.Id == dto.ConditionType);
		
		this.Value = dto.Value;
		this.VisibleCondition = dto.VisibleCondition;      
        return this;
	}

	mapToDto() {
		let vp = JSON.parse(JSON.stringify(this));

		if(vp.ParentQuestionId)
			vp.ParentQuestionId = vp.ParentQuestionId.Id;
			
		vp.RelationType = vp.RelationType.Id;		
		vp.ConditionType = vp.ConditionType.Id;
		
		switch (vp.ConditionType) {
			//Любой текст
			case 1: vp.Value = null; break;
			case 2: break;
	
			//Число
			case 10:
			case 11:
			case 12:
				vp.Value = vp.Value + "";
				break;
	
			//Выбор из списка
			case 20:
			case 21:
				vp.Value = vp.Value.Id + "";
				break;
	
			//Выбран контакт
			case 30:
				vp.Value = null;
				break;
	
			// ДА/НЕТ
			case 40:
			case 41:
				vp.Value = vp.Value === null ? null
					: vp.Value === true ? "true"
						: "false";
				break;
	
			//AEP'ы
			case 100:
			case 101:
				vp.Value = null;
				break;
	
			//Торговая точка является сетью
			case 200:
				vp.Value = vp.Value === null ? null
					: vp.Value === true ? "true"
						: "false";
				break;
            
            //От типа торговой точки
			case 201:
                vp.Value = vp.Value.Text;
				break;

			case 202:
				vp.Value = vp.Value.Name;
				break;
			case 203:
			case 204:
				vp.Value = JSON.stringify(vp.Value.map(e => e.Id));
				break;

			//Торговая точка находится в регионе
			case 206:
				vp.Value = JSON.stringify(vp.Value.map(v => { return { Name: v.Name, Codes: v.Codes } }));
				break;
		}
        
        return vp;
	}
	
	//Валидна ли текущая модель (true/false)
	isValid = function () {
		var isRelationType = isNotNull(this.RelationType);
		var isParentQuestionId = this.RelationType.Id === 2 || isNotNull(this.ParentQuestionId);
		var isConditionType = isNotNull(this.ConditionType);

		return isRelationType &&
			   isParentQuestionId &&
			   isConditionType;
	}
    // +++++ Получение Value +++++

    getModelValueForAnswerType(questionOptions) {
        if (this.Value === null || typeof (this.Value) === "undefined" || this.Value === "")
            return null;
            
            switch (this.ParentQuestionId.AnswerType) {

                //Произвольный ответ
                case 1: return this.Value + "";

                //Число
                case 10:
                case 11:
                case 12:
                    return +this.Value;

                //Выбор из списка
                case 20:
                case 21:
                case 22:
                    return questionOptions.find(e => e.Id == this.Value)

                //Выбор контакта
                case 30:
                    return this.Value;

                // ДА/НЕТ/NULL
				case 40:
					return this._getNullableBoolean(this.Value);


                default:
                    return this.Value;
            }
    }

    getModelTTValueForConditionType(branches, regions, networks, ttTypes) {
		if (this.Value === null || typeof (this.Value) === "undefined" || this.Value === "")
			return null;

		switch (this.ConditionType.Id) {

			//Торговая точка является сетью
			case 200:
				return this._getNullableBoolean(this.Value);

			//У торговой точки указанный тип
			case 201:
				return ttTypes.find(e => e.Text === this.Value);

			//Торговая точка относится к указанному филиалу
			case 202:
				return branches.find(e => e.Name === this.Value);

			//Торговая точка относится/не относится к сети
			case 203:
			case 204:
				var networksArray = JSON.parse(this.Value);
				return networksArray.map(e => networks.find(n => n.Id === e));
			
			//Торговая точка находится в регионе
			case 206:
				return JSON.parse(this.Value);

			default:
				console.error(`Не корректное conditionType для тт ${this.ConditionType.Id}. Value: ${this.Value}`);
				return this.Value;
		}

	}

    //Получить null/true/false для Nullable<Bool>
    _getNullableBoolean(value) {
        return value === "true" ? true
            : value === "false" ? false : null;
    }

    // +++++ ГЕТТЕРЫ +++++

    //Получить тип условия (число) текущей политики
	getConditionType = function () {
		if (typeof (this.ConditionType) === "undefined" || this.ConditionType === null) return 0;

		return this.ConditionType.Id;
    }
    
    //Получить типы условий для текущего типа ответа
	getConditionTypes = function () {
		var answerType = this.getParentAnswerType();
		if (answerType === 0) return [];

		var result = Consts.AnswerToConditionTypes.get(answerType);
		return result;
	}

	getParentQuestionId = function () {
		if (typeof (this.ParentQuestionId) === "undefined" ||
			this.ParentQuestionId === null ||
			this.ParentQuestionId.AnswerType === null)
			return 0;

		return this.ParentQuestionId.Id;
	}

    	//Получить числовой тип ответа на вопрос
	getParentAnswerType = function () {
		if (typeof (this.ParentQuestionId) === "undefined" ||
			this.ParentQuestionId === null ||
			this.ParentQuestionId.AnswerType === null)
			return 0;

		return this.ParentQuestionId.AnswerType;
	}

	//Действие при изменении вопроса к которому относится политика
	onSelectParentQuestion = function () {
		this.ConditionType = null;
		this.Value = null;
	}

    // +++++ ВОТЧИ (ИНФА О ТЕКУЩЕЙ МОДЕЛИ) +++++

	//Политика относится к вопросу
	isForQuestion = function () {
		return typeof (this.RelationType) !== "undefined" &&
			   this.RelationType !== null &&
			   this.RelationType.Id === 1;
	}

	//Политика относится к ТТ
	isForTradePoint = function () {
		return typeof (this.RelationType) !== "undefined" &&
			   this.RelationType !== null &&
			   this.RelationType.Id === 2;
	}

	//Зависимость от вопроса с числом
	isNumberAnswer = function () {
		var answerType = this.getParentAnswerType();
		return answerType === 10 ||
			   answerType === 11 ||
			   answerType === 12;
	}

	//Зависимость от вопроса с выбором из списка
	isSelectAnswer = function () {
		var answerType = this.getParentAnswerType();
		return answerType === 20 ||
			   answerType === 21 ||
			   answerType === 22;
	}   
}

function isNotNull(object) {
	return typeof (object) !== "undefined" && object !== null;
}